// extracted by mini-css-extract-plugin
export default {"Counter":"Counter_Counter__RG+WB","boxContainer":"Counter_boxContainer__APvXl","box":"Counter_box__SduUT"};